import wx from 'weixin-js-sdk';
import fetch from './fetch';

let fenxiang = function fenxiang(curUrl, shareUrl, title, desc, iconUrl) {
  // var u = navigator.userAgent;
  // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // let signLink = '';
  // let iosurl = ''
  // if (isIOS) {
  //   const { origin, pathname, search, hash } = window.location;
  //   iosurl = `${origin}${pathname}${search}${hash}`;
  //   signLink = iosurl.split('#')[0];
  //   alert('ioslink:' + signLink)
  // } else {
  //   const url = location.href.split('#')[0];
  //
  //   // 记录进入app时的url
  //   if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
  //     window.entryUrl = location.href.split('#')[0];
  //   }
  //   // 进行签名的时候  Android 不用使用之前的链接， ios 需要
  //   signLink = /(Android)/i.test(navigator.userAgent)
  //     ? location.href.split('#')[0]
  //     : window.entryUrl;
  // }

  const appId = localStorage.getItem('appId');
  let apiUrl =
    '/pdd-user/public/weixin/signature?appId=' +
    appId +
    '&url=' +
    encodeURIComponent(curUrl);

  // 获取微信分享签名的后台接口   传当前页面url地址
  fetch({
    url: apiUrl,
    method: 'get'
  }).then(response => {
    console.log(response.data.appId);
    // 微信jsapi中的config接口注入权限验证配置
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: response.data.appId, // 必填，公众号的唯一标识
      timestamp: response.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
      signature: response.data.signature, // 必填，签名
      jsApiList: [
        'updateAppMessageShareData', //微信好友
        'updateTimelineShareData', // 朋友圈
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'hideOptionMenu'
      ] // 必填，需要使用的JS接口列表
    });

    // 检验js接口
    wx.checkJsApi({
      jsApiList: [
        'updateAppMessageShareData', //获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
        'updateTimelineShareData', // 微信好友
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'hideOptionMenu'
      ],
      success: function(res) {
        //这里没返应 也没提示，也不会进断点
      },
      fail: function(res) {
        console.log(res);
        // alert('check fail')
        // alert(JSON.stringify(res));
      }
    });
    //通过ready接口处理成功验证
    wx.ready(function() {
      wx.hideAllNonBaseMenuItem();
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
      });
      wx.updateAppMessageShareData({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: iconUrl, // 分享图标
        success: function() {
          // 设置成功
        },
        fail: function(res) {
          // alert('updateAppMessageShareData fail')
          // alert(shareUrl)
          // alert(JSON.stringify(res));
        },
        cancel: function(res) {
          // 用户取消分享后执行的回调函数
        }
      });
      wx.updateTimelineShareData({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: iconUrl, // 分享图标
        success: function() {
          // 设置成功
        }
      });

      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    });

    wx.error(function(res) {
      console.log('error');
      console.log(JSON.stringify(res));
      //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });
  });
};

export default {
  fenxiang //多个方法在此处json中export出去
};
